import { render } from "./home.vue?vue&type=template&id=485844ef&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=485844ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485844ef"]])

export default __exports__